import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";

interface MediaCardProps {
  item: MediaItem;
  showUpdated?: boolean;
}

export default function MediaCard({ item, showUpdated = false }: MediaCardProps) {
  return (
    <Link to={`/detail/${item.type}/${item.id}`} className="group block">
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={item.poster}
          alt={`${item.title}海报`}
          title={`${item.title} - 91n影视大全`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        <span className="absolute top-2 left-2 h-6 px-2 rounded-md bg-accent-500 text-background-50 text-xs font-bold flex items-center gap-1">
          <i className="ri-star-fill text-[11px]"></i>
          {item.rating.toFixed(1)}
        </span>

        <span className="absolute top-2 right-2 h-6 px-2 rounded-md bg-black/60 text-white text-xs font-medium flex items-center">
          {item.type === "movie" ? "电影" : "剧集"}
        </span>

        <span className="absolute bottom-2 right-2 h-6 px-2 rounded-md bg-white/85 text-foreground-900 text-xs font-medium flex items-center">
          {item.year}
        </span>

        <span className="absolute bottom-2 left-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-white text-xs font-medium flex items-center gap-1">
          <i className="ri-play-circle-fill text-base"></i>
          查看详情
        </span>
      </div>

      <h3 className="mt-2.5 text-sm md:text-[15px] font-semibold text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
        {item.title}
      </h3>
      <p className="mt-0.5 text-xs text-foreground-500 truncate">
        {item.genres.join(" · ")} · {item.region}
      </p>
      {showUpdated && item.updatedTo && (
        <p className="mt-0.5 text-xs text-primary-500 font-medium truncate">{item.updatedTo}</p>
      )}
    </Link>
  );
}